import {
  sendTourRequest,
  sendRoomReservation,
  sendSoupRequest,
  sendGetConnectedRequest,
} from '../config/emailjs';
import {
  isMonthBlocked,
  isBeforeEarliestBookable,
} from './tourDateValidation';
import {
  TOUR_BLOCKED_MONTHS,
  TOUR_BOOKING_BUFFER_BUSINESS_DAYS,
  TOUR_JULY_UNAVAILABLE_MESSAGE,
} from '../constants/tourBooking';

function getTourDateField(formDef) {
  return formDef?.fields?.find((f) => f.name === 'preferred_date');
}

/**
 * Routes form submission to the correct EmailJS handler.
 * Template IDs stay in env/config — never exposed via CMS.
 */
export async function submitSiteForm(handler, formData, formDef, formKey) {
  let result;

  switch (handler) {
    case 'tour': {
      const dateField = getTourDateField(formDef);
      const blockedMonths = dateField?.blockedMonths?.length
        ? dateField.blockedMonths
        : TOUR_BLOCKED_MONTHS;
      const bufferDays =
        dateField?.minBufferBusinessDays ?? TOUR_BOOKING_BUFFER_BUSINESS_DAYS;

      if (isMonthBlocked(formData.preferred_date, blockedMonths)) {
        return {
          success: false,
          message: dateField?.blockedMonthMessage || TOUR_JULY_UNAVAILABLE_MESSAGE,
        };
      }
      if (isBeforeEarliestBookable(formData.preferred_date, bufferDays)) {
        return {
          success: false,
          message: 'Please choose a later date.',
        };
      }
      result = await sendTourRequest(formData);
      break;
    }
    case 'room':
      result = await sendRoomReservation(formData);
      break;
    case 'soup':
      result = await sendSoupRequest(formData);
      break;
    case 'get_connected':
      result = await sendGetConnectedRequest(formData);
      break;
    case 'mailing_list':
      return {
        success: false,
        message: 'Mailing list uses Constant Contact — use the Mailing List page.',
      };
    case 'generic_email': {
      try {
        const res = await fetch('/api/forms/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ formKey, formData }),
        });
        const data = await res.json();
        if (data.success && formDef?.successMessage) {
          return { ...data, message: formDef.successMessage };
        }
        if (!data.success && formDef?.errorMessage) {
          return { ...data, message: formDef.errorMessage };
        }
        return data;
      } catch {
        return {
          success: false,
          message: formDef?.errorMessage || 'Failed to send. Please try again or contact us directly.',
        };
      }
    }
    default:
      return {
        success: false,
        message: 'This form is not configured for submission.',
      };
  }

  if (result.success && formDef?.successMessage) {
    return { ...result, message: formDef.successMessage };
  }
  if (!result.success && formDef?.errorMessage) {
    return { ...result, message: formDef.errorMessage };
  }
  return result;
}
